import React, {ComponentType, useState} from "react";
/**
 * Gets the interface types as array of strings so we don't need hand code them each time (and reduces chance for mistakes).
 */
import {keys} from 'ts-transformer-keys';
import {hot} from "react-hot-loader";
import ReactUtilsService from "app/services/reactUtils.service";
import ResizeBackgroundPanel from './index';

import { Provider } from 'react-redux';
import store from 'appRoot/Store';

const NS = 'ResizeBackgroundPanelContainer';

const ThemeWrap = function() {


  return ReactUtilsService.containerWrap(
    <Provider store={store}>
      <ResizeBackgroundPanel />
    </Provider>
  );
}

/**
 * Returns properties needed for rendering react2angular
 */
export const R2AResizeBackgroundPanel: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>,
  [] as never[], // no continer props needed  
];
